

// ตรวจสอบว่าแอปกำลังรันอยู่บน Localhost หรือไม่ (รองรับทั้ง localhost, [::1], และ 127.0.0.1)
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

/**
 * ฟังก์ชันหลักสำหรับการลงทะเบียน Service Worker
 * @param {Object} config - วัตถุรับ Callback เช่น { onSuccess, onUpdate }
 */
export function register(config) {
  // ทำงานเฉพาะเมื่ออยู่ใน Production และเบราว์เซอร์รองรับ Service Worker
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    
    // สร้าง URL ของ Public Origin เพื่อตรวจสอบว่าอยู่บน Domain เดียวกันหรือไม่
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // หาก Origin ไม่ตรงกัน (Cross-origin) จะปฏิเสธการลงทะเบียน
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // หากรันบน Localhost จะทำการตรวจสอบว่าไฟล์ service-worker.js มีอยู่จริงไหม
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          console.log(
            "Web App นี้กำลังทำงานแบบ Cache-First ผ่าน Service Worker ในเครื่อง Localhost"
          );
        });
      } else {
        // หากอยู่บน Server Production จริง ให้ลงทะเบียน Service Worker ทันที
        registerValidSW(swUrl, config);
      }
    });
  }
}

/**
 * ฟังก์ชันลงทะเบียน Service Worker เมื่อยืนยันว่าไฟล์มีอยู่จริง
 */
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // ตรวจสอบเมื่อมีการอัปเดตไฟล์ Service Worker เวอร์ชันใหม่
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // กรณี: มีไฟล์แคชเวอร์ชันใหม่พร้อมใช้งานแล้ว
              console.log(
                "มีเนื้อหาใหม่พร้อมใช้งาน จะเปลี่ยนเป็นเวอร์ชันใหม่เมื่อปิด Tab ทั้งหมดแล้ว"
              );

              // เรียก Callback onUpdate หากมีการส่งมาจากภายนอก
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // กรณี: แคชไฟล์ทั้งหมดสำเร็จเป็นครั้งแรก (พร้อมใช้งาน แบบ Offline)
              console.log("บันทึกแคชข้อมูลสำเร็จ พร้อมสำหรับการใช้งาน Offline");

              // เรียก Callback onSuccess หากมีการส่งมาจากภายนอก
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("เกิดข้อผิดพลาดในการลงทะเบียน Service Worker:", error);
    });
}

/**
 * ฟังก์ชันตรวจสอบความถูกต้องของไฟล์ Service Worker บน Localhost
 */
function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      
      // หากไม่พบไฟล์ (404) หรือชนิดของไฟล์ไม่ใช่ JavaScript
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // ยกเลิกการลงทะเบียน Service Worker และรีโหลดหน้าเว็บ
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // หากไฟล์ถูกต้อง ให้ลงทะเบียน Service Worker ต่อ
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("ไม่พบการเชื่อมต่ออินเทอร์เน็ต ระบบกำลังทำงานในโหมด Offline");
    });
}

/**
 * ฟังก์ชันสำหรับยกเลิกการลงทะเบียน Service Worker
 */
export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log("ยกเลิกการลงทะเบียน Service Worker เรียบร้อยแล้ว");
      })
      .catch((error) => {
        console.error(error.message);
      });
      console.log(process.env.NODE_ENV);
  }
}